var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#646A82;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.6,13.4c-0.6,0-1-0.2-1.4-0.6c-0.4-0.4-0.6-0.9-0.6-1.4c0-0.6,0.2-1,0.6-1.4C6.5,9.5,7,9.4,7.6,9.4 c0.6,0,1,0.2,1.4,0.6c0.4,0.4,0.6,0.9,0.6,1.4c0,0.6-0.2,1-0.6,1.4C8.6,13.2,8.1,13.4,7.6,13.4z M4.3,17.8c-0.4,0-0.8-0.2-1.1-0.5 c-0.3-0.3-0.5-0.7-0.5-1.1V5c0-0.4,0.2-0.8,0.5-1.1s0.7-0.5,1.1-0.5h0.8V2.6c0-0.2,0.1-0.4,0.2-0.6c0.2-0.2,0.3-0.2,0.6-0.2 c0.2,0,0.4,0.1,0.6,0.2s0.2,0.3,0.2,0.6v0.8h6.4V2.6c0-0.2,0.1-0.4,0.2-0.6s0.3-0.2,0.6-0.2s0.4,0.1,0.6,0.2 c0.2,0.2,0.2,0.3,0.2,0.6v0.8h0.8c0.4,0,0.8,0.2,1.1,0.5C17,4.1,17.1,4.5,17.1,5v11.2c0,0.4-0.2,0.8-0.5,1.1 c-0.3,0.3-0.7,0.5-1.1,0.5H4.3z M4.3,16.1h11.2v-8H4.3V16.1z M4.3,6.6h11.2V5H4.3V6.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSingle);
export default __webpack_public_path__ + "static/media/Calendar-Single.ee6fa41546d9c06e409e5fe90439585a.svg";
export { ForwardRef as ReactComponent };